import BobTVError from './error';

export function responseResolveInterceptor(response) {
    let {status, message, messages, ...rest} = response.data;

    if (!status || status !== 'success') {
        let error = new BobTVError(messages || message || '');
        error.code = response.data.code;
        error.data = response.data.data;
        return Promise.reject(error);
    }

    return Promise.resolve({message, ...rest});
}

export let requestInterceptor;

export const cookiesRequest = cookies => {
    if (cookies) {
        requestInterceptor = config => {
            config.headers.cookie = cookies;
            return config;
        }
    }
}


// WEBPACK FOOTER //
// ./src/backend-helpers/interceptors.js